import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
//eslint-disable-next-line
import styles from "./TopArtists.module.css"

const TopArtistsCompNew = (props) => {
  const [topArtists, setTopArtists] = useState([])
  
  useEffect(() => {
    const getTopArtists = async () => {
      const topArtistsAllTimeRes = await fetch(
        "https://api.spotify.com/v1/me/top/artists?limit=50&time_range=long_term&offset=0",
        {
          headers: { 
            Authorization: "Bearer " + sessionStorage.getItem("accessToken")
          }
        }
      );
      let topArtistsAllTimeData = await topArtistsAllTimeRes.json();
  
      //set Alltime top Artists to state
      setTopArtists(topArtistsAllTimeData.items)
    }
      getTopArtists()
  }, [])
  
  return (
    <div>
        <h3>Top Artist:</h3>
        <ul>
          {topArtists.map(artist => (
            <li key={artist.uri}>{artist.name}</li>
          ))}
        </ul>
      </div>
  )
}

TopArtistsCompNew.propTypes = {
  accessToken: PropTypes.string.isRequired
}

export default TopArtistsCompNew
